<template>
  <div class="sm:px-10 md:px-32 lg:px-64 my-10 bg-gray-500 py-10">
    <BackButton @back="back('submit-request')" />
    <v-card class="my-1">
      <v-card-title primary-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        <div>
          <HighlightButton :height="50" :selection="selection1" />
        </div>
      </v-card-text>
    </v-card>

    <v-card class="my-1">
      <v-card-title primary-title>
        {{ title2 }}
        <div class="font-light text-sm">
          {{ note2 }}
        </div>
      </v-card-title>
      <v-card-text>
        <!-- <HighlightButton :height="50" :selection="selection2" /> -->
        <div v-for="(item, i) in selection2" :key="i" class="flex items-center">
          <img src="/icons/check.png" alt="check" width="24" class="mr-2 my-2 items-center"> <div class="text-lg">{{ item.title}}</div>
        </div>
      </v-card-text>
    </v-card>
    <v-card class="my-1">
      <v-card-title primary-title>
        {{ title3 }}
        <div class="font-light text-sm">
          {{ note3 }}
        </div>
      </v-card-title>
      <v-card-text>
        <HighlightButton :height="50" :selection="selection3" />
      </v-card-text>
    </v-card>
    <!-- component for axios submit -->
    <AlertDialog
      :props_data="props_data"
      :showAlert="showAlert"
      @alertDialogSubmit="alertDialogSubmit"
    />
    <div class="my-2 w-full">
      <v-btn class="w-full" color="blue" @click="submitTicket">
        Submit Request</v-btn
      >
    </div>
    <!-- ================== -->
  </div>
</template>

<script>
import HighlightButton from "@/common/HighlightButton.vue";
import BackButton from "@/common/BackButton.vue";
import AlertDialog from "../../common/AlertDialog.vue";
export default {
  data() {
    return {
      props_data: {},
      justification: "",
      amount: "",
      modeOfPayment: "",
      excessPaymentMadeFor: null,
      title: "Issuance of Move-in Clearance",
      title2: "Move-in Requirements",
      title3: "Select One:",
      note1: "Select your financing scheme:",
      // note2:
      //   "Ensure you have already complied with the Move-in requirements. Select the requirements you have not complied with for further assistance",
      showAlert: false,
      selection1: [
        // {
        //   title: "InHouse Financing",
        //   id: 1,
        // },
        // {
        //   title: "Bank / Pagibig Financing",
        // },
      ],
      selection2: [
        {
          title: "Paid 20% down payment",
          id: 1,
        },
        {
          title: "Issue 24 post-dated checks",
          id: 2,
        },
        {
          title: "Paid Registration Fee",
          id: 3,
        },
        { title: "Paid Real Property Tax", id: 4 },
        { title: "Paid Move-in Fee / Water & Electric", id: 5 },
        { title: "Signed Contract to Sell", id: 6 },
        { title: "With loan proceeds", id: 7 },
      ],
      selection3: [
        {
          title: "I need further assistance",
          id: 1,
        },
        {
          title: "I have complied with all the requirements",
          id: 2,
        },
      ],
    };
  },
  components: {
    AlertDialog,
    BackButton,
    HighlightButton,
  },
  methods: {
    back(n) {
      this.$router.push({ name: n });
    },
    submitTicket() {
      this.showAlert = true;
      this.props_data = {
        status_id: 1,
        remarks_id: 1,
        classification_id: this.$route.meta.classification_id,
        request_type_id: this.$route.meta.request_type_id,
        department_id: 10,
        subject: this.$route.meta.subject,
      };
    },
    alertDialogSubmit(name) {
      this.showAlert = false;
      !this.$route.path.includes(name) ? this.$router.push(name) : null;
    },
  },
};
</script>